import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ReplaySubject } from 'rxjs';
import { UserService } from '@services/user.service';
import { ISideNavItem, ISideNavHeader } from './side-nav.interface';

@Injectable()
export class SideNavService {
  public items: (ISideNavItem | ISideNavHeader)[];
  public itemsVisible$: ReplaySubject<(ISideNavItem | ISideNavHeader)[]> = new ReplaySubject<
    (ISideNavItem | ISideNavHeader)[]
  >(1);

  constructor(
    private userService: UserService,
    public translocoService: TranslocoService,
  ) {
    // update visibility when user is updated
    this.userService.userUpdated$.subscribe(() => {
      this.updateVisibility();
    });
  }

  updateVisibility() {
    if (this.items) {
      const itemsVisible = [];

      for (const item of this.items) {
        // check permissions to item
        if (item.permission && !this.userService.userHasSitePermission(item.permission)) {
          item.visible = false;

          continue;
        }

        // set visibility for the item object
        item.visible = true;

        // push to new visible items
        itemsVisible.push(item);

        // call onload function if one exists and the item has not yet been loaded
        if ('onload' in item && !item.loaded) {
          item.onload(item);
          item.loaded = true;
        }
      }

      // update observable
      this.itemsVisible$.next(itemsVisible);
    }
  }
}
